import { useAnalytics } from '@ecosystem/newron-client-lib';
import { mapInternalEventParams } from './tools';
import { add } from './queue';
import { MappingFn } from './types';
import { TrackingEventOptions, TrackingMeta } from '../types';
import { isTrackingEnabled } from './enabled';

export const useTracking = (mappingFn: MappingFn) => {
  const { track } = useAnalytics();

  return {
    trackEvent: (eventName: string, meta: TrackingMeta, options: TrackingEventOptions) => {
      if (!mappingFn) return; //For DP!
      if (isTrackingEnabled(eventName)) {
        const eventParams = {
          eventName,
          params: mapInternalEventParams(eventName, meta, mappingFn(eventName, meta)),
        };
        if (options.fireEvent === false) {
          return eventParams.params;
        } else {
          add(eventParams, track);
        }
      }
    },
  };
};
